import { render, staticRenderFns } from "./SecaoNossoProjeto.vue?vue&type=template&id=7d5f5f26&scoped=true"
import script from "./SecaoNossoProjeto.vue?vue&type=script&lang=js"
export * from "./SecaoNossoProjeto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5f5f26",
  null
  
)

export default component.exports